import { Route } from "@dashboard/components/Router";
import { sectionNames } from "@dashboard/intl";
import { vendorOfferingsPath, VendorListUrlQueryParams } from "@dashboard/vendors/urls";
import VendorOfferings from "@dashboard/vendors/views/VendorOfferings";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { RouteComponentProps, Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";

const VendorOfferingsView = ({ location }: RouteComponentProps) => {
  const qs = parseQs(location.search.substr(1));
  const params: VendorListUrlQueryParams = qs as any;
  
  return <VendorOfferings params={params} />;
};

export const VendorOfferingsSection = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.vendorOfferings)} />
      <Switch>
        <Route exact path={vendorOfferingsPath} component={VendorOfferingsView} />
      </Switch>
    </>
  );
};

export default VendorOfferingsSection;